/**
 * Shared helpers for populating a review/reference card dialog from the clicked
 * slider card. Used by both review-dialog.ts and reference-dialog.ts.
 */

export const text = (el: Element | null | undefined): string => el?.textContent?.trim() ?? "";

export const setAvatar = (slot: HTMLElement | null, card: HTMLElement) => {
  if (!slot) {
    return;
  }
  const picture = card.querySelector("picture");
  slot.innerHTML = "";
  if (picture) {
    const clone = picture.cloneNode(true) as HTMLElement;
    const img = clone.querySelector("img");
    if (img) {
      img.style.width = "100%";
      img.style.height = "auto";
    }
    slot.appendChild(clone);
  }
};
